import { TextProps, Text as UIKittenText } from "@ui-kitten/components";
import { isSmallScreen } from "constants/";
import { Image } from "expo-image";
import { selectThemeColor } from "features/slices/tenantSlice";
import { EventDetails } from "features/types";
import { useAppSelector } from "hooks/useAppSelector";
import i18n from "plugins/localization";
import React from "react";
import { Pressable, StyleSheet, View } from "react-native";
import { formatEventDate, isSportsEvent } from "utils/eventUtils";
import { svgURL } from "utils/fileUtils";
import Spacer from "./Spacer";
import GernericEventBackground from "./GernericEventBackground";
interface EventBannerProps {
  event: EventDetails;
  type?: "RESERVE" | "DASHBOARD" | "EVENT_AVAILABILITY ";
  heldTicketLength?: number;
  onPress?: () => void;
  bannerText?: string;
}

// Make text white by default
const Text: React.FC<TextProps> = (props) => {
  const { style } = props;
  return (
    <UIKittenText {...props} style={[style, { color: "white" }]}></UIKittenText>
  );
};

const EventBanner: React.FC<EventBannerProps> = (props) => {
  const {
    event: { opponentName, name, imageUrl, type: eventType, hostName },
    type,
    heldTicketLength,
    onPress,
    bannerText,
  } = props;
  const themeColor = useAppSelector(selectThemeColor);
  const opponentSVG = svgURL(opponentName);
  const hostSVG = svgURL(hostName);
  const SVG_SIZE = 160;
  const isSportsEventType = isSportsEvent(eventType);

  if (!isSportsEventType) {
    if (!imageUrl) {
      return <GernericEventBackground />;
    }

    return (
      <Image
        style={{
          aspectRatio: isSmallScreen ? 16 / 9 : 21 / 9,
          borderRadius: 15,
        }}
        source={{ uri: imageUrl }}
        responsivePolicy="initial"
        contentFit="fill"
      />
    );
  }

  return (
    <Pressable
      style={{
        borderRadius: 10,
        height: 150,
        alignItems: "center",
        justifyContent: "center",
        backgroundColor: themeColor,
      }}
      onPress={onPress}
    >
      <View
        style={[
          StyleSheet.absoluteFill,
          { borderRadius: 10, overflow: "hidden" },
        ]}
      >
        <View style={[{ left: -25 }, styles.commonSvgStyle]}>
          <Image
            source={{ uri: opponentSVG }}
            style={{ width: SVG_SIZE, height: SVG_SIZE }}
            responsivePolicy="initial"
            contentFit="contain"
          />
        </View>
        <View style={[{ right: -25 }, styles.commonSvgStyle]}>
          <Image
            source={{ uri: hostSVG }}
            style={{ width: SVG_SIZE, height: SVG_SIZE }}
            responsivePolicy="initial"
            contentFit="contain"
          />
        </View>
      </View>

      <View style={{ justifyContent: "center", alignItems: "center" }}>
        {type === "DASHBOARD" && (
          <View style={{ marginBottom: 20 }}>
            <Text category="h6">
              {i18n.t("components.EventBanner.nextUpcomingEvent")}
            </Text>
          </View>
        )}

        <View
          style={{
            flexDirection: "row",
            alignItems: "baseline",
            justifyContent: "center",
            minWidth: 375,
          }}
        >
          <Text category="h6" style={{ flex: 0.45, textAlign: "center" }}>
            {name}
          </Text>
        </View>
        <View style={{ marginTop: 5 }}>
          {type !== "EVENT_AVAILABILITY " && (
            <Text category="s1">{formatEventDate(props.event)}</Text>
          )}
          <Text category="s1" style={{ textAlign: "center" }}>
            {props.event.venueName}
          </Text>
        </View>

        <Spacer />

        {type === "RESERVE" && heldTicketLength !== undefined && (
          <View>
            {bannerText ? (
              <Text>{bannerText}</Text>
            ) : (
              <Text>
                {i18n
                  .t("components.EventBanner.seatsOnHold", {
                    amount: heldTicketLength,
                    seats: i18n.t("common.seat", {
                      count: heldTicketLength,
                    }),
                  })
                  .toLowerCase()}
              </Text>
            )}
          </View>
        )}
      </View>
    </Pressable>
  );
};

const styles = StyleSheet.create({
  commonSvgStyle: {
    position: "absolute",
    opacity: 0.5,
    bottom: -20,
  },
});
export default EventBanner;
